"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ApiSubClient_1 = require("../../common/client/ApiSubClient");
const LinkEntity_1 = require("../../common/model/LinkEntity");
class ApiCustomMetadataClient extends ApiSubClient_1.ApiSubClient {
    async uploadCustomMetadataCsv(file) {
        const formData = new FormData();
        formData.append('file', file);
        const config = {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        };
        const uploadCustomMetadataLink = new LinkEntity_1.Link(this.getLinkOrThrow('uploadCustomMetadata'));
        uploadCustomMetadataLink.getTemplatedLink({});
        if (!uploadCustomMetadataLink)
            throw new Error(`Not authorized`);
        return this.axios
            .post(uploadCustomMetadataLink.getTemplatedLink({}), formData, config)
            .then((response) => Promise.resolve(response.data.message))
            .catch((error) => Promise.reject(error.message));
    }
}
exports.default = ApiCustomMetadataClient;
//# sourceMappingURL=ApiCustomMetadata.js.map